import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../../shared/components/PortalLayout';
import { useAuth, userIsAdmin, userIsReviewer, userIsEngineer } from '../../context/AuthContext';
import client from '../../api/client';
import SupervisorListPage from './SupervisorListPage';
import SupervisorDetailPage from './SupervisorDetailPage';
import ReviewerListPage from './ReviewerListPage';
import ReviewerDashboard from './ReviewerDashboard';

function SupervisorTabs({ employees }) {
  const { user } = useAuth();
  const isRev = userIsReviewer(user);
  const isEng = userIsEngineer(user);

  // Pure reviewer (not engineer/admin): show only pending_review receipts for final approval
  if (isRev && !isEng) {
    return <ReviewerListPage employees={employees} />;
  }

  // Engineer (or admin): show L1 approval queue
  return <SupervisorListPage employees={employees} />;
}

export default function SupervisorView() {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    client.get('/api/users/employees')
      .then(res => setEmployees(res.data))
      .catch(err => console.error('Failed to load employees:', err));
  }, []);

  return (
    <PortalLayout activeModule="gastos">
      <Routes>
        <Route index element={<SupervisorTabs employees={employees} />} />
        <Route path="dashboard" element={<ReviewerDashboard />} />
        <Route path="receipt/:id" element={<SupervisorDetailPage />} />
      </Routes>
    </PortalLayout>
  );
}
